import ErrorPage from '../pages/general/ErrorPage'

export default [
  {
    path: '/error',
    component: ErrorPage,
    name: 'error',
    meta: {
      title: 'Whoops, Something Went Wrong!',
    },
  },
]
